export default "__VITE_ASSET__5a1850cc__"